import React from 'react';
import { Link, useParams } from 'react-router-dom';

import { useTag } from 'src/queries/tag';
import ErrorContainer, { parseAxiosError } from 'src/Layouts/ErrorContainer';
import { StyledDate } from 'src/UIComponents';
import FormattedDate from 'src/Components/FormattedDate';
import { TagTitle, TagColor } from './Tag.styles';

function TagDetails(props) {
  const { id } = useParams();
  const { isLoading, error, data: tag = {} } = useTag(id);

  if (isLoading) {
    return null;
  }

  if (error) {
    return <ErrorContainer {...parseAxiosError(error)} />;
  }

  return (
    <div {...props}>
      <Link
        style={{
          float: 'right',
        }}
        to={`/tags/${tag.id}/edit`}
      >
        Edit
      </Link>
      <TagTitle color={tag.color}>{tag.title}</TagTitle>

      <div>
        <StyledDate>
          <FormattedDate value={tag.createdAt} />
        </StyledDate>
        {tag.createdAt !== tag.updatedAt && (
          <StyledDate className="ml-2">
            (
            <FormattedDate value={tag.updatedAt} />)
          </StyledDate>
        )}
      </div>

      <TagColor color={tag.color}>{tag.color}</TagColor>

      <h4 className="mt-3">Somethings</h4>
      <ul>
        {tag.Somethings.length === 0 && (
          <span
            style={{
              fontSize: '2em',
            }}
          >
            🤷🏼‍♀️
          </span>
        )}
        {tag.Somethings.map((something) => (
          <li key={`tag-something-${something.id}`}>
            <Link to={`/somethings/${something.id}`}>{something.title}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TagDetails;
